module.exports = __webpack_public_path__ + "img/5.10b80870.jpg";